import * as React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import OrdemServicoItem from '../components/OrdemServicoItem';
import { useQuery } from '../hooks/useQuery';
import { useSnackbar } from '../hooks/useSnackbar';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useAuth } from '../hooks/useAuth';
import CustomizedDialogs from '../components/ModalAlert';
import CustomizedDialogsOS from '../components/ModalAlertOS';
import ModalAlertOSDetalhe from '../components/ModalAlertOSDetalhe';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import { encryptData, serializeQueryString } from '../utils';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import readXlsxFile from 'read-excel-file';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';
import { useCustomState } from '../hooks/useCustomState';
import { useWindowSize } from '@uidotdev/usehooks';

export const SelecionarOrdemServicoPage = ({
  activeStep,
  setActiveStep,
  steps,
  contratoId,
  nfs,
  cnpj,
  isContract,
  contratoDts,
  gestor,
}) => {
  const [height, setHeight] = React.useState(0);
  const elementRef = React.useRef(null);
  const [file, setFile] = React.useState();
  const [filtroBusca, setFiltroBusca] = React.useState({
    numero_search: '',
    description_search: '',
    valor_search: '',
  });
  let [searchParams, setSearchParams] = useSearchParams();
  const [usersComunicacao, setUsersComunicacao] = React.useState([]);
  const [errorXLSX, setErrorXLSX] = useCustomState([]);
  const [ordersXLSX, setOrdersXLSX] = React.useState([]);
  const [ordens, setOrdens] = React.useState([]);
  const [ordensErro, setOrdensErro] = React.useState([]);
  const {
    detalheContrato,
    enviarOrdemServico,
    detalhePedido,
    obterOrdemsDeServicoPeloIdDaNota,
  } = useQuery();

  const { user, isUsuarioSebrae } = useAuth();
  const [show, setShow] = React.useState(false);
  const [showOS, setShowOS] = React.useState(false);
  const [showOSDetalhe, setShowOSDetalhe] = React.useState(false);
  const [ordensDetalhe, setOrdensDetalhe] = React.useState([]);
  const [isHtml, setIsHtml] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loadingExcel, setLoadingExcel] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [lastSearch, setLastSearch] = React.useState(null);
  const [checkAll, setCheckAll] = React.useState(false);
  const { search } = useLocation();
  const snackbar = useSnackbar();
  const paramsSearch = new URLSearchParams(search);
  const theme = useTheme();
  const inputFile = React.useRef();
  const navigate = useNavigate();
  const size = useWindowSize();

  React.useEffect(() => {
    setHeight(size.height - 400);
  }, [size.height]);

  React.useEffect(() => {
    getContratoDetalhes();
    setUsersComunicacao(JSON.parse(process.env.REACT_APP_USERS_SUBCONTRATADA));
  }, []);

  const converToFloat = (currency) => {
    let result = String(currency).split('.').join('');
    result = result.replace(',', '.');

    var value = parseFloat(result);
    return value.toFixed(2);
  };

  const getContratoDetalhes = async () => {
    try {
      setLoading(true);

      const { data } = await obterOrdemsDeServicoPeloIdDaNota(nfs.id);
      const ordensSalvoNota = data.data;
      let arrOrdens = [];

      if (isContract) {
        const paramsFiltro = serializeQueryString(filtroBusca, '&');

        const { data: detalhe_contrato } = await detalheContrato(
          contratoDts,
          paramsFiltro,
        );

        detalhe_contrato.data.forEach((resul) => {
          resul.itens.map((res) => {
            if (res.tipo_controle === 'Medição') {
              res.ordens.map((orden) => {
                const medicoesComSaldo = orden.Medicoes.filter(
                  (item) => item.saldo_medicao !== '0,00',
                );
                medicoesComSaldo.map((med) => {
                  med.tipo_controle = res.tipo_controle;
                  if (usersComunicacao.includes(searchParams.get('gestor'))) {
                    med.tipo_documento = '2';
                  } else {
                    med.tipo_documento =
                      detalhe_contrato.data[0].tipo_documento;
                  }
                  med.item_id = orden.item;
                  med.valor_ordem = converToFloat(med.valor_medicao);
                  med.saldo_ordem = converToFloat(med.saldo_medicao);
                  med.descricao = orden.descricao;
                  med.cta_contabil = orden.cta_contabil;
                  med.centro_custo = orden.centro_custo;
                  med.unid_negoc = orden.unid_negoc;
                  med.cod_estab = orden.cod_estab;
                  med.nom_requisitante = orden.nom_requisitante;
                  med.requisitante = orden.requisitante;
                  med.seq_medicao = med.seq_medicao;
                  med.unidade = med.und;
                  med.id_ordem_compra = `${med.ordem_compra} | ${med.seq_medicao}`;
                  med.ind_selecionado = null;
                  med.gestor_tecnico = detalhe_contrato.data[0].gestor_tecnico;
                  med.nom_gestor = detalhe_contrato.data[0].nom_gestor;
                  med.matricula_contrato = detalhe_contrato.data[0].matricula;
                  med.fornecedor = detalhe_contrato.data[0].fornecedor;
                  med.valor_final = 0;
                  arrOrdens.push(med);
                });
              });
            } else {
              res.ordens.map((orden) => {
                orden.tipo_controle = res.tipo_controle;
                if (usersComunicacao.includes(searchParams.get('gestor'))) {
                  orden.tipo_documento = '2';
                } else {
                  orden.tipo_documento =
                    detalhe_contrato.data[0].tipo_documento;
                }
                orden.item_id = res.item;
                orden.valor_ordem = converToFloat(orden.valor_ordem);
                orden.saldo_ordem = converToFloat(orden.saldo_ordem);
                orden.id_ordem_compra = orden.ordem_compra;
                orden.ind_selecionado = null;
                orden.valor_final = 0;
                orden.gestor_tecnico = detalhe_contrato.data[0].gestor_tecnico;
                orden.nom_gestor = detalhe_contrato.data[0].nom_gestor;
                orden.matricula_contrato = detalhe_contrato.data[0].matricula;
                orden.fornecedor = detalhe_contrato.data[0].fornecedor;

                arrOrdens.push(orden);
              });
            }
          });
        });
      } else {
        let result = await detalhePedido(contratoId);
        if (
          result.data &&
          result.data.data &&
          result.data.data.ordem &&
          result.data.data.pedido
        ) {
          result.data.data.ordem.map((orden) => {
            orden.nom_gestor = result.data.data.pedido[0].nom_responsavel;
            orden.gestor_tecnico = result.data.data.pedido[0].responsavel;
            orden.tipo_controle = '';
            orden.matricula_contrato = result.data.data.pedido[0].matricula;
            orden.tipo_documento = '5';
            orden.item_id = orden.item;
            orden.fornecedor = result.data.data.pedido[0].fornecedor;
            orden.id_ordem_compra = orden.ordem_compra;
            orden.valor_final = 0;
            orden.ind_selecionado = null;
            arrOrdens.push(orden);
          });
        }
      }

      arrOrdens.forEach((ordem) => {
        const itemSalvo = ordensSalvoNota.find(
          ({ numero_ordem_servico, seq_medicao }) => {
            if (seq_medicao) {
              return (
                `${numero_ordem_servico} | ${seq_medicao}` ===
                ordem.id_ordem_compra
              );
            } else {
              return numero_ordem_servico === ordem.id_ordem_compra;
            }
          },
        );

        if (itemSalvo !== undefined) {
          // Valores dos contratos podem sofrer alterações, então é necessário verificar se o valor salvo é igual ao valor atual da OS, caso seja diferente, não deve ser marcado como selecionado.
          if (
            itemSalvo.ind_selecionado === 'parcial' &&
            itemSalvo.valor_final <= parseFloat(ordem.saldo_ordem)
          ) {
            ordem.checked = true;
            ordem.ind_selecionado = itemSalvo.ind_selecionado;
            ordem.valor_final = itemSalvo.valor_final;
          }

          if (
            itemSalvo.ind_selecionado === 'total' &&
            itemSalvo.outro_valor === parseFloat(ordem.saldo_ordem)
          ) {
            ordem.checked = true;
            ordem.ind_selecionado = itemSalvo.ind_selecionado;
            ordem.outro_valor = itemSalvo.outro_valor;
          }
        }
      });

      setOrdens(arrOrdens);
      setIsSelectedAll();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const setIsSelectedAll = () => {
    setTimeout(() => {
      const itemsSelected = ordens.filter(({ checked }) => checked === true);
      if (itemsSelected.length === ordens.length) {
        setCheckAll(true);
      } else {
        setCheckAll(false);
      }
    }, 300);
  };

  const downlodModelo = () => {
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = `${process.env.REACT_APP_API_BASE_URL}modeloOS.xlsx`;
    link.click();
  };

  const buscarOrdem = async () => {
    if (!filtroBusca.numero_search || filtroBusca.numero_search == '') {
      const section = document.getElementById(lastSearch);
      if (!section) return;
      section.style.backgroundColor = 'rgb(255, 255, 255)';
    } else {
      if (lastSearch !== null) {
        const sectionLast = document.getElementById(lastSearch);
        sectionLast.style.backgroundColor = 'rgb(255, 255, 255)';
      }

      const section = document.getElementById(
        String(filtroBusca.numero_search),
      );
      if (!section) return;

      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      section.style.backgroundColor = '#eee';
      setLastSearch(String(filtroBusca.numero_search));
    }
  };

  const onChangeSelectAll = () => {
    setCheckAll(!checkAll);
    const items = ordens.map((item) => ({
      ...item,
      checked: !checkAll,
      valor_final: 0,
    }));

    setOrdens([]);
    setTimeout(() => {
      setOrdens(items);
    }, 100);
  };

  const onChangeOrdem = (id, ordem) => {
    const updatedItems = ordens.map((item) =>
      item.id_ordem_compra === id ? { ...item, ...ordem } : item,
    );
    setOrdens([...updatedItems]);
  };

  const onChangeSelected = (id) => {
    const updatedItems = ordens.map((item) =>
      item.id_ordem_compra === id
        ? { ...item, checked: !item.checked, valor_final: 0 }
        : item,
    );

    setOrdens([...updatedItems]);

    if (checkAll) {
      const hasItemUnselected = updatedItems.filter(
        ({ checked }) => checked === false,
      );

      if (hasItemUnselected.length) {
        setCheckAll(false);
      }
    }

    const itemsSelected = updatedItems.filter(
      ({ checked }) => checked === true,
    );
    if (itemsSelected.length === updatedItems.length) {
      setCheckAll(true);
    }
  };

  const getTotal = () => {
    const total = ordens
      .filter(({ checked }) => checked === true)
      .reduce((acc, item) => (acc += item.valor_final), 0);

    // ex: transforma 1.5699999999999998 para 1.57
    return Math.round(total * 100) / 100;
  };

  const formatValorBR = (valueFloat) => {
    return Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valueFloat);
  };

  const handleNext = async (isRascunho) => {
    let send = {
      data: ordens.filter(({ checked }) => checked === true),
      user: user.nome_usuario,
      nota_fiscal_id: nfs.id,
    };

    if (!isRascunho && parseFloat(nfs.valor_servico) !== getTotal()) {
      setMessage(
        'O valor total das OS selecionadas deve ser igual ao valor total da nota.',
      );
      setType('error');
      setIsHtml(false);
      setShow(true);
      return;
    }

    try {
      await enviarOrdemServico(send);

      if (!isRascunho) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      } else {
        const dataEncrypted = encryptData(
          JSON.stringify({
            contrato: contratoId,
            cnpj: cnpj,
            contrato_dts: contratoDts,
            is_contract: isContract,
            gestor: gestor,
          }),
        );

        navigate(`/dashboard/notas/${dataEncrypted}`, {});
        return;
      }
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.errors
      ) {
        let arrErrors = [];
        setMessage(error.response.data.message.errors);
        setOrdensErro(error.response.data.message.ordens);
        setIsHtml(false);
        setType('error');
        setShowOS(true);
      }

      return;
    }
  };

  const canGoToNext = () => {
    return ordens.filter(({ checked }) => checked === true).length > 0;
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleCloseOS = () => {
    setShowOS(false);
  };

  const changeExcelFile = async (event) => {
    setErrorXLSX([], async () => {
      const file = event.target.files[0];
      const extension = file.name.split('.').pop();

      if (!['xls', 'xlsx'].includes(extension)) {
        snackbar.showSnackbar('Atenção: Tipo de Arquivo Inválido!');
        return;
      }

      setLoadingExcel(true);

      const rows = await readXlsxFile(file);
      setOrdersXLSX(rows);
      inputFile.current.value = '';
      setLoadingExcel(false);
    });
  };

  React.useEffect(() => {
    if (ordersXLSX.length === 0) return;

    try {
      if (ordersXLSX.length === 1) {
        throw 'O arquivo que você tentou enviar está vazio. Por favor, certifique-se de que o arquivo contém dados antes de fazer o upload novamente.';
      }

      ordersXLSX.forEach((res, index) => {
        if (index === 0) return;

        let find = ordens.find((os) => os.id_ordem_compra == res[0]);

        if (find && find.saldo_atual < res[1]) {
          errorXLSX.push(
            "<Box style={{width: '100%', fontSize: 20}}>A OS " +
              res[0] +
              ' não tem saldo suficiente.</Box>',
          );
        }
        if (!find) {
          errorXLSX.push(
            "<Box style={{width: '100%', fontSize: 20}}>A OS " +
              res[0] +
              ' não existe.</Box>',
          );
        }
      });

      const ordensComValorErrado = [];

      ordersXLSX.forEach((element, index) => {
        if (index === 0) return;
        const id_ordem_compra = element[0];
        let valor = element[1];

        ordens.forEach((item) => {
          if (id_ordem_compra === null) {
            throw 'Informe o número da Ordem de Serviço (OS).';
          }
          if (item.id_ordem_compra === id_ordem_compra) {
            if (isNaN(valor) || isNaN(parseFloat(valor))) {
              throw `Informe o valor referente a Ordem de Serviço ${item.id_ordem_compra}`;
            }

            let saldo_ordem = item.saldo_ordem;
            if (typeof item.saldo_ordem === 'string') {
              saldo_ordem = parseFloat(
                saldo_ordem.includes(',')
                  ? saldo_ordem.replace('.', '').replace(',', '.')
                  : saldo_ordem,
              );
            }

            if (parseFloat(valor) > saldo_ordem) {
              ordensComValorErrado.push(id_ordem_compra);
              return;
            }
            item.valor_final = parseFloat(valor);
            item.ind_selecionado = 'parcial';
            item.checked = true;
          }
        });
      });

      if (ordensComValorErrado.length) {
        throw `Valor maior que o saldo disponível OS: (${ordensComValorErrado.join(
          ', ',
        )})`;
      }

      setOrdens([]);
      setTimeout(() => {
        setOrdens([...ordens]);
      }, 500);

      setMessage('Importação concluída com sucesso.');
      setIsHtml(false);
      setType('success');
      setShow(true);
      setIsSelectedAll();
    } catch (error) {
      snackbar.showSnackbar(error.toString());
    }
  }, [ordersXLSX]);

  const clickDetalheModal = (ordem) => {
    let arr = [];
    ordensErro.map((os) => {
      os.map((result) => {
        if (result.numero_ordem_servico == ordem) {
          arr.push(result);
        }
      });
    });

    setType('error');
    setOrdensDetalhe(arr);
    setShowOSDetalhe(true);
  };

  return (
    <Grid
      ref={elementRef}
      container
      spacing={1}
      paddingY="2rem"
      paddingX="1rem"
    >
      <CustomizedDialogs
        content={message}
        btnTxt={'Ok'}
        type={type}
        onClick={() => setShow(false)}
        handleClose={handleClose}
        visible={show}
        isHtml={isHtml}
      />
      <CustomizedDialogsOS
        content={message}
        btnTxt={'Ok'}
        type={type}
        onClick={() => setShowOS(false)}
        handleClose={handleCloseOS}
        visible={showOS}
        isDetalhe={isHtml}
        onClickDetalhe={clickDetalheModal}
      />
      <ModalAlertOSDetalhe
        content={ordensDetalhe}
        btnTxt={'Ok'}
        type={type}
        handleClose={() => setShowOSDetalhe(false)}
        onClick={() => setShowOSDetalhe(false)}
        visible={showOSDetalhe}
      />
      <Grid
        item
        sm={10}
        xs={12}
        className="scrollbar"
        id="style-3"
        style={{ height: `${height}px`, overflowY: 'scroll' }}
      >
        {!loading && ordens.length > 0 ? (
          <Button variant="contained" style={{ margin: 10 }} component="label">
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {loadingExcel ? (
                <CircularProgress color={'inherit'} size={25} />
              ) : (
                <span> Importar rateio</span>
              )}
            </Box>
            <FileUploadIcon style={{ color: 'white', marginLeft: 5 }} />
            <input
              hidden
              ref={inputFile}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              type="file"
              onChange={changeExcelFile}
            />
          </Button>
        ) : null}
        {!loading && ordens.length > 0 ? (
          <Button
            onClick={downlodModelo}
            variant="contained"
            style={{ margin: 10 }}
            component="label"
          >
            Baixar modelo importação
            <DownloadIcon style={{ color: 'white', marginLeft: 5 }} />
          </Button>
        ) : null}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress style={{ marginTop: 60 }} />
          </Box>
        ) : (
          <table className="app_table" role="table">
            <caption
              style={{
                textAlign: 'left',
                padding: '1rem',
                fontWeight: 600,
                fontSize: '0.95rem',
              }}
            >
              Ordens de serviço disponíveis
            </caption>
            <thead
              style={{
                color: theme.palette.primary.main,
                borderTop: `8px solid ${theme.palette.primary.light}`,
              }}
            >
              <tr
                style={{
                  background: '#fff',
                }}
              >
                <th
                  scope="col"
                  style={{
                    width: '5%',
                  }}
                >
                  <Box>
                    <FormControlLabel
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        alignItems: 'center',
                      }}
                      control={
                        <Checkbox
                          checked={checkAll}
                          onChange={onChangeSelectAll}
                          aria-label="Selecionar todas as ordens de serviço"
                        />
                      }
                    />
                  </Box>
                </th>
                <th
                  scope="col"
                  style={{ width: '15%', padding: 10, fontSize: '0.86rem' }}
                >
                  Nº O.S
                </th>
                <th
                  scope="col"
                  style={{ width: '20%', padding: 10, fontSize: '0.86rem' }}
                >
                  Descrição
                </th>
                <th
                  scope="col"
                  style={{ width: '45%', padding: 10, fontSize: '0.86rem' }}
                >
                  Informe o valor a ser utilizado por Ordem de serviço
                </th>
              </tr>
            </thead>
            <tbody>
              {ordens.map((ordem, index) => {
                return (
                  <OrdemServicoItem
                    ordem={ordem}
                    nfs={nfs}
                    isContract={isContract}
                    index={index}
                    key={ordem.id_ordem_compra}
                    onChangeSelected={onChangeSelected}
                    onChangeOrdem={onChangeOrdem}
                  />
                );
              })}
              {!loading && ordens.length === 0 ? (
                <tr>
                  <td colSpan={5} align="center">
                    Nenhuma Ordem de Serviço encontrada.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        )}

        <Card
          variant="outline"
          style={{
            borderTop: `8px solid ${theme.palette.primary.light}`,
            background: '#E7F0FF',
            position: 'fixed',
            bottom: 0,
            width: '68%',
            padding: 0,
          }}
        >
          <CardContent style={{ padding: 0 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: 10,
              }}
            >
              <p style={{ color: '#0e72b8' }}>
                Valor total da nota: <b>{formatValorBR(nfs.valor_servico)}</b>
              </p>
              <p
                style={{
                  color:
                    nfs.valor_servico - getTotal() < 0 ? '#DC143C' : '#0e72b8',
                }}
              >
                Valor Restante:{' '}
                <b>{formatValorBR(nfs.valor_servico - getTotal())}</b>
              </p>
              <p style={{ color: '#0e72b8' }}>
                Total da O.S. selecionadas:
                <b>{formatValorBR(getTotal())}</b>
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: 10,
                background: '#fff',
              }}
            >
              <Button
                variant="contained"
                color="warning"
                style={{ marginRight: '0.5rem' }}
                onClick={() => {
                  handleNext(true);
                  snackbar.showSnackbar('Rascunho salvo com sucesso.');
                }}
              >
                Salvar como rascunho
                <SaveIcon />
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  handleNext(false);
                }}
                variant="contained"
                disabled={!canGoToNext()}
              >
                Próximo
                <ArrowRightAltIcon color={!canGoToNext() ? '#e0e0e0' : ''} />
              </Button>
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid item sm={2} style={{ height: '500px' }}>
        <Card
          variant="outlined"
          style={{
            borderTop: `8px solid ${theme.palette.primary.light}`,
          }}
        >
          <CardContent>
            <p
              style={{
                color: '#0e72b8',
                marginTop: 0,
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FilterAltIcon color="primary" />
              Filtro
            </p>
            <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>Nº da ordem</p>
            <TextField
              style={{ width: '100%' }}
              label="Nº da ordem"
              variant="outlined"
              value={filtroBusca.numero_search}
              onChange={({ target }) =>
                setFiltroBusca({ ...filtroBusca, numero_search: target.value })
              }
            />
            <Button
              variant="contained"
              style={{ width: '100%', marginTop: 20 }}
              onClick={buscarOrdem}
            >
              Buscar
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
